// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_hf-7";
export var emphasizeQuantity = "_hf-3";
export var flatBottomCorners = "_hf-5";
export var productImage = "_hf-0";
export var quantityContainer = "_hf-2";
export var quantityHeader = "_hf-6";
export var tooltip = "_hf-1";
export var wrapAndEllipsesOverflow = "_hf-4";